import React, { forwardRef } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import Spacings, { createCustomSpacing, } from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import Link from '@polestar/component-warehouse-react/components/link/Link';
import { SideNavigationList } from './SideNavigationList';
import SideNavigationContainer from '@polestar/component-warehouse-react/components/side-navigation/internal/SideNavigationContainer';
import warnOnce from '@polestar/component-warehouse-react/helpers/warnOnce';
const SideNavigationDefault = forwardRef(({ items, offset, ...props }, ref) => {
    return (React.createElement(SideNavigationContainer, { ...props, ref: ref, offset: offset, desktopOnly: true },
        React.createElement(SideNavigationList, null, items.map(({ label, href, active, onClick, onLinkClick, ...itemProps }, index) => {
            var _a;
            if (href.startsWith('#')) {
                warnOnce('SideNavigationDefault', `SideNavigationDefault: Items should only be Links not anchors: ${label} starts with "#".`);
            }
            const handleClick = (e) => {
                onClick === null || onClick === void 0 ? void 0 : onClick(e);
                onLinkClick === null || onLinkClick === void 0 ? void 0 : onLinkClick(index);
            };
            return (React.createElement(LinkWrapper, { key: `side-navigation-link-${index}` },
                React.createElement(StyledLink, { href: href, onClick: handleClick, selected: active, ...itemProps }, label),
                ((_a = itemProps.items) === null || _a === void 0 ? void 0 : _a.length) > 0 && active && (React.createElement(SubLinks, null, itemProps.items.map(({ label, href, active, onClick, onLinkClick, ...subItemProps }, index) => {
                    const handleSubLinkClick = (e) => {
                        onClick === null || onClick === void 0 ? void 0 : onClick(e);
                        onLinkClick === null || onLinkClick === void 0 ? void 0 : onLinkClick(index);
                    };
                    // TODO: Can we do this? Is it okey with full url if it contains a hash?
                    if (!href.includes('#')) {
                        warnOnce('SideNavigationDefault', `SideNavigationDefault - nested items: Second level items should only be anchors: ${label} doesn't include a "#".`);
                    }
                    return (React.createElement(SubLinkWrapper, { key: `side-navigation-sublink-${index}` },
                        React.createElement(StyledAnchorLink, { href: href, onClick: handleSubLinkClick, selected: active, ...subItemProps }, label)));
                })))));
        }))));
});
SideNavigationDefault.displayName = 'SideNavigationDefault';
export default SideNavigationDefault;
const LinkWrapper = styled.li `
  ${({ theme }) => css `
    display: flex;
    flex-direction: column;
    box-shadow: inset 0px -${createCustomSpacing(2 / 16)} ${createCustomSpacing(1 / 16)} -${createCustomSpacing(1 / 16)}
      ${theme.sideNavigation.border.color};
  `}
`;
const StyledLink = styled(Link)(({ theme, selected }) => css(css `
      text-decoration: none;
      padding: ${Spacings.small} 0;

      &:hover {
        text-decoration: none;
      }

      &:active {
        color: ${theme.sideNavigation.link.selectedColor};
      }
    `, selected &&
    css `
        color: ${theme.sideNavigation.link.selectedColor};
      `));
const SubLinks = styled.ul `
  list-style: none;
  padding: ${createCustomSpacing(7 / 16)} 0 ${createCustomSpacing(19 / 16)} 0;
  margin: 0;
`;
const SubLinkWrapper = styled.li `
  display: flex;
`;
const StyledAnchorLink = styled(Link)(({ theme, selected }) => css(css `
      text-decoration: none;
      padding: ${createCustomSpacing(5 / 16)} 0;

      &:hover {
        text-decoration: none;
      }

      &:active {
        color: ${theme.sideNavigation.link.selectedColor};
      }
    `, selected &&
    css `
        color: ${theme.sideNavigation.link.selectedColor};
      `));
